module.exports = __webpack_public_path__ + "static/img/img_4.c83ad4cc.jpg";